import React from 'react'
import configureStore from '../../shared/configure_store'
import GgGolfHubReducer from '../reducers/dashboard/dashboard_index'
import { GlobalProvider } from '../../shared/global_context'
import PropTypes from 'prop-types'
import GgGolfHubDashboardComponent from './gg_golf_hub_dashboard_component'

const GgGolfHubDashboardRoot = (initialState) => {
  const state = {
    events: {
      events: [],
      numberOfLeagues: initialState.numberOfLeagues,
      totalAmount: initialState.totalAmount,
      totalGolfers: initialState.totalGolfers,
    },
    misc: {
      customerId: initialState.customerId,
      helpItems: initialState.helpItems,
      discoverUrl: initialState.discoverUrl,
      userFirstName: initialState.userFirstName,
      getLeaguesPath: initialState.getLeaguesPath,
    },
  }

  const store = configureStore(GgGolfHubReducer, state)

  return (
    <GlobalProvider store={store}>
      <GgGolfHubDashboardComponent/>
    </GlobalProvider>
  )
}

GgGolfHubDashboardRoot.propTypes = {
  initialState: PropTypes.any,
}

export default GgGolfHubDashboardRoot
